export interface DraftPreviewItem {
  tempId: string;
  question: string;
  answer: string;
  type: 'objection' | 'faq';
}

const words = (value: string) => Array.from(new Set(
  value.toLowerCase().match(/[a-z0-9]+/g)?.filter((word) => word.length > 1) || []
));

/** Lightweight whole-draft preview matching. This deliberately searches
 * only the selected unpublished strings supplied by the review screen; it
 * never calls or represents the live retrieval index. */
export const findDraftMatches = (query: string, items: DraftPreviewItem[]) => {
  const terms = words(query);
  if (!terms.length) return [];

  return items
    .map((item) => {
      const question = item.question.toLowerCase();
      const corpus = `${question} ${item.answer}`.toLowerCase();
      const matched = terms.filter((term) => corpus.includes(term)).length;
      const score = matched / terms.length + (question.includes(query.toLowerCase()) ? 1 : 0);
      return { item, score };
    })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map(({ item }) => item);
};
